export enum ImpersonationEvent {
  STARTED = 'STARTED',
  ENDED = 'ENDED',
}

export interface IImpersonatedUser {
  companyId: number;
  companyName: string;
  id: number;
  isAdmin: boolean;
  name: string;
  primaryEmail?: string;
}
